import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import ForumsMeet from "./ForumsMeet";
import UsersMeet from "./UsersMeet";
import {config} from "../../../config";
import Helmet from "react-helmet";
import {canonical} from "../../../libs/helper";
import createLink from "../../../libs/createLink";


class Meet extends React.Component {

    render() {
        return (
            <div id="meet">
                <Helmet>
                    <title>{config.preTitle}Rencontre{config.postTitle}</title>
                    <link rel="canonical" href={canonical(createLink("dating"),  window.location.search || "", "dating")} />
                </Helmet>
                <div className="container">
                    <div className="card big">
                        <div className="main-wrapper">
                            <UsersMeet match={this.props.match} history={this.props.history}/>
                            <ForumsMeet/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // currentUser: state.currentUser.data,
        // currentUserLoading: state.currentUser.loading,
        // currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Meet);
